<template>
    <div>
      <van-cell-group title="支付信息">
        <van-cell title="标题" :value="payment.name" />
        <van-cell title="金额(元)" :value="payment.fee" />
      </van-cell-group>
      <div style="text-align:center; margin-top: 50px"></div>
      <br />
      <br />
      <br />
      <div style="margin: 10px">
        <van-button type="primary" block @click="checkPayment">重新支付</van-button>
        <br/>
        <van-button block @click="back">返回</van-button>
      </div>
      <van-overlay :show="loading" @click="show = false">
        <div class="wrapper" @click.stop>
          <van-loading class="block" vertical>{{loadingCause}}</van-loading>
        </div>
      </van-overlay>
    </div>
</template>

<script>
import qs from 'query-string';
import { Button, Cell, CellGroup, Dialog, Loading, Overlay } from 'vant';
import { router } from '../router';

const addPaidParam = (url, paid) => {
  let p = '?paid=' + paid;
  if (url.includes('?')) {
    p = '&paid=' + paid
  }
  const clearUrl = url.replace(/&?paid=(true|false)/g, '');
  const u = clearUrl.split('#');
  if (u.length > 1) {
    p = u[0] + p + '#' + u[1];
  } else {
    p = clearUrl + p;
  }
  return p;
}

export default {
  components: {
    [Button.name] : Button,
    [Loading.name] : Loading,
    [CellGroup.name] : CellGroup,
    [Cell.name] : Cell,
    [Overlay.name] : Overlay
  },
  data() {
    return {
      payment: {},
      loading: true,
      loadingCause : '准备支付....',
      callback: null,
      timer: null,
      checkTimes: 5,
      isMiniProgram: false,
      tradeNo: null
    };
  },
  mounted() {
    const q = qs.parse(location.search);
    const {callback,  tradeNo} = q;
    this.callback = callback;
    this.tradeNo = tradeNo;

    const that = this;
    this.$wechat.sdk(sdk => {
        sdk.miniProgram.getEnv(function(res) {
          that.isMiniProgram = res.miniprogram;
          if (that.isMiniProgram) {
            console.log('miniprogram env')
          }
          that.checkPayment();
        })
    });
    
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    async checkPayment(){
      
      const state = await this.$http.get('/payment', {tradeNo : this.tradeNo});
      if (state.payable) {
        const that = this;
        // 如果是在小程序内，则调用小程序支付
        if (this.isMiniProgram && state.fee) {
          this.$wechat.sdk(sdk => {
              sdk.miniProgram.navigateTo({
                url: '/pages/payment/payment?tradeNo=' + that.tradeNo
              })
          });
          Dialog.alert({
            message: '正在支付',
          }).then(() => {
            this.startCheckIfPaid(1);
          });
        } else {
          this.setLoading(true, '准备支付....');
          try {
            this.payment = await this.$http.post('/payment/wechat_pay', {tradeNo: this.tradeNo});
            this.processPayment();
          } catch(e) {
            this.setLoading(false);
          }
        }
        
      } else {
        this.setLoading(false);
        this.alertAndBack(state.cause);
      }
    },
    back(){
      router.push(addPaidParam(this.callback, false));
    },
    setLoading(loading, cause) {
      this.loading = loading;
      this.loadingCause = cause;
    },
    startCheckIfPaid(times) {
      this.setLoading(true, '等待结果....');
      clearInterval(this.timer);
      this.checkTimes = times || 5;
      this.timer = setInterval(async ()=>{
        const state = await this.$http.get('/payment', {tradeNo : this.tradeNo});
        if (state.paid) {
          clearInterval(this.timer);
          const url = addPaidParam(this.callback, true);
          router.push(url);
        } else if (this.checkTimes <= 0){
          clearInterval(this.timer);
          this.alertAndBack('支付失败');
        } else {
          this.checkTimes--;
        }
      }, 3000)
    },
    processPayment() {
      const payment = this.payment;
      const that = this;
      if (payment.fee == 0) {
          this.startCheckIfPaid();
      } else {
          const jsSign = payment.jsPaySign;
          jsSign.success = function(res) {
            if (res && res.errMsg && res.errMsg == 'chooseWXPay:ok') {
              that.startCheckIfPaid();
            } else {
                  that.alertAndBack();
            }
          }
          jsSign.complete = function() {
              
          }
          jsSign.fail = function() {
              that.alertAndBack();
          }
          jsSign.cancel = jsSign.fail;

          this.$wechat.sdk(sdk => {
              sdk.chooseWXPay(jsSign);
          });
      }
    },
   alertAndBack(cause) {
     this.setLoading(false);
     Dialog.alert({
        title: '支付错误',
        message: cause,
      }).then(() => {
        if (this.callback) {
          router.push(addPaidParam(this.callback, false));
        }
      });
   }
  }
};
</script>

<style lang="less" scoped>
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .block {
    width: 100px;
    height: 80px;
    display: flex;
    justify-content: center;
    background-color: #fff;
    padding: 10px 0;
    border-radius: 5px;
  }
</style>